/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Players_View_SanctionsInputs */



/**
* | output |
* | --- |
* | "View sanctions" |
*
* @param {Players_View_SanctionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const players_view_sanctions = /** @type {((inputs?: Players_View_SanctionsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Players_View_SanctionsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Voir les sanctions")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ver sanciones")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ver sanções")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vedi sanzioni")
	return /** @type {LocalizedString} */ ("View sanctions")
});